import React, { useEffect, useState } from "react";
import config from "../../config";

const SampleRequestForm = () => {
  const containerStyle = {
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f8f9fa", // Light gray background
  };
  const [embeddFormLink, setEmbeddedFormLink] = useState("");

  const iframeStyle = {
    width: "100%",
    height: "100%",
    border: "none",
  };

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}config-options/new_fundraiser_request_id`
        );
        const data = await response.json();
        setEmbeddedFormLink(data[0]?.config_value || ""); // Ensure fallback to empty if no form is set
      } catch (error) {
        console.error("Error Fetching Sample Request Form:", error);
      }
    };

    fetchForm();
    document.title = "New Fundraiser Request";
  }, []);

  return (
    <div style={containerStyle}>
      {embeddFormLink ? (
        <iframe
          src={`https://docs.google.com/forms/d/e/${embeddFormLink}/viewform?embedded=true`}
          style={iframeStyle}
          title="New Fundraiser Request"
        >
          Loading…
        </iframe>
      ) : (
        <div style={{ textAlign: "center", fontSize: "18px", color: "#333" }}>
          New Fundraiser Request Form not set, please contact MamFam support.
        </div>
      )}
    </div>
  );
};

export default SampleRequestForm;
